<template>
  <div class="selection-container">
    <div class="action-header">
      <el-row>
        <el-button type="primary" @click="handleAdd">添加入选信息</el-button>
        <el-upload 
            :action="importAction"
            name="content"
            :show-file-list="false"
            :on-success="handleImportSuccess"
            :on-error="handleImportError"
        >
          <el-button type="primary">上传入选信息</el-button>
        </el-upload>
        <el-button @click="handleDownloadTemplate">下载入选模板</el-button>
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="playerName">
        <template slot="header" slot-scope="scope">
          <div>运动员姓名</div>
          <el-input
            v-model="search.playerName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="cardNo">
        <template slot="header" slot-scope="scope">
          <div>证件号</div>
          <el-input
            v-model="search.cardNo"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatLevel"
        prop="level">
        <template slot="header" slot-scope="scope">
          <div>级别</div>
          <el-select v-model="search.level" filterable clearable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="season">
        <template slot="header" slot-scope="scope">
          <div>年度</div>
          <el-input
            v-model="search.season"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name">
        <template slot="header" slot-scope="scope">
          <div>名称（赛事名称或球队名称）</div>
          <el-input
            v-model="search.name"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"/>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form ref="dialogForm" :model="dialogForm" :rules="rules" class="modal" label-width="100px">
        <el-form-item label="证件号" prop="cardNo">
            <el-input v-model="dialogForm.cardNo" />
        </el-form-item>
        <el-form-item label="姓名" prop="playerName">
            <el-input v-model="dialogForm.playerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="级别" prop="level">
          <el-select filterable v-model="dialogForm.level" placeholder="请选择">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="年度" prop="season">
            <el-input v-model="dialogForm.season" />
        </el-form-item>
        <el-form-item label="名称" prop="name">
            <el-input v-model="dialogForm.name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import { getSelectionList, getSelectionListPagination, addSelection, getSelection, deleteSelection, updateSelection, getPlayerByCardNo, getImportSelectionUrl, getImportSelectionTemplateUrl } from '@/api/stats'
import { showMessage } from '@/utils'

const defaultForm = {
  cardNo: '',
  playerName: '',
  level: '',
  season: '',
  name: ''
}

export default {
  name: 'selectionList',
  data() {
    return {
      search: {},
      list: [],
      dialogForm: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      isEditMode: false,
      modalTitle: '',
      dialogVisible: false,
      formLabelWidth: '100px',
      rules: {
        cardNo: [
          { required: true, message: '请输入证件号', trigger: 'blur' },
          { validator: this.validateCardNo, trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择级别', trigger: 'blur' }
        ],
        season: [
          { required: true, message: '请输入年度', trigger: 'blur' },
          { pattern: /^\d{4}$/, message: '请输入4位年份数字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入赛事名称或队伍名称', trigger: 'blur' }
        ]
      },
      levelList: [
        { label: '国家队', value: 1 },
        { label: '北京队', value: 2 },
        { label: '区队', value: 3 },
      ]
    }
  },
  created() {
    this.getList()
  },
  computed: {
      importAction() {
          return getImportSelectionUrl()
      }
  },
  watch: {},
  methods: {
    handleImportError() {
        showMessage('error', '导入失败')
    },
    handleImportSuccess(response) {
        // console.log('handleImportSuccess', arguments)
        if (response.ok) {
            showMessage('success', '导入成功，共' + response.messages.affectedRows + '条有效记录')
            this.getList()
        }
        else {
            showMessage('error', '导入失败')
        }
    },
    handleDownloadTemplate() {
        window.open(getImportSelectionTemplateUrl(), '_blank')
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加入选信息'
      this.dialogForm = Object.assign({}, defaultForm)
    },
    handleEdit(index, row) {
      this.getSelectionById(this.list[index].id)
      this.dialogVisible = true
      this.isEditMode = true
      this.modalTitle = '编辑入选信息'
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该入选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteSelection(this.list[index].id)
      }).catch(() => {
      })
    },
    formatLevel: function(row, column) {
      const level = this.levelList.find(item => item.value === row[column.property])
      return level && level.label
    },
    // dialog form methods
    validateCardNo(rule, value, callback) {
        // console.log('validateCardNo', rule, value)
        getPlayerByCardNo(value).then(response => {
            const data = response
            if (data && data.length > 0) {
                const player = data[0]
                this.dialogForm.playerId = player.playerId
                this.dialogForm.playerName = player.playerName
                callback()
            }
            else {
                this.dialogForm.playerId = ''
                this.dialogForm.playerName = ''
                callback(new Error('无效的证件号'))
            }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.isEditMode) {
            this.updateSelection()
          } else {
            this.addSelection()
          }
        } else {
          return false
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getSelectionList(this.listQuery).then(response => {
        const data = response
        this.list = data
        this.listLoading = false
      })
      getSelectionListPagination(this.listQuery).then(response => {
        const data = response[0]
        this.currentPage = data.pageNum
        this.totalCount = data.count
      })
    },
    getSelectionById(id) {
      getSelection(id).then(response => {
        const data = response[0]
        this.dialogForm = data
      })
    },
    addSelection() {
      addSelection(this.dialogForm).then(response => {
        const data = response
        if(data) {
          this.dialogVisible = false
          showMessage('success', '创建成功')
          this.getList()
        }
      })
    },
    updateSelection() {
      updateSelection(this.dialogForm).then(response => {
        const data = response
        if(data) {
          this.dialogVisible = false
          showMessage('success', '更新成功')
          this.getList()
        }
      })
    },
    deleteSelection(id) {
      deleteSelection(id).then(response => {
        const data = response
        if(data) {
          showMessage('success', '删除成功')
          this.getList()
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.selection-container {
  margin: 30px 15px;
  .action-header {
    padding: 0 10px 10px 10px;
    .el-row {
      .el-button,.el-upload,div {
        display: inline-block;
      }
    }
  }
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }

  /* dialog modal start */
  .el-dialog {
    width: 540px;
    .el-form-item {
      .el-input {
        width: 300px;
      }
    }
  }
  /* dialog modal end*/
}
</style>
